import React, { memo } from 'react';
import styled from 'styled-components';

import AncillaryServicesIcon from 'assets/v2/AncillaryServicesIcon';
import { COLORS } from 'theme';
import { TRIP_TYPE_NAMES } from 'utils/constants';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.amethystDark};
    background: ${COLORS.amethystLight};
    border-color: ${COLORS.amethyst};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.amethystDark};
    }
  }
`;

function AncillaryServicesTripTypeTag(props) {
  return (
    <StyledTag
      label={TRIP_TYPE_NAMES.ANCILLARY_SERVICES}
      icon={<AncillaryServicesIcon />}
      {...props}
    />
  );
}

export default memo(AncillaryServicesTripTypeTag);
